const LANGUAGE_CODE_MAP_TO_NAME: Record<string, string> = {
  en: 'English',
  ru: 'Русский',
  ar: 'العربية',
};

export function getLanguageNameByCode(languageCode: string): string {
  return LANGUAGE_CODE_MAP_TO_NAME[languageCode] || '';
}
